import { FC, } from "react"
import { useTranslation } from "react-i18next"
import { useGET_learningStyleQuestionsQuery, } from "redux/api/studentsApi"
import { PRIMARY_YELLOW, PRIMARY_ORANGE, PRIMARY_PINK, PRIMARY_BLUE, PRIMARY_RED } from "utils/customizedTheme"


const PLOP_COLORS = [
    PRIMARY_YELLOW,  
    PRIMARY_ORANGE,
    PRIMARY_PINK,
    PRIMARY_BLUE,
    PRIMARY_RED
 ]

interface IProps {
  student: any
  subject: any
}

const ProgramStudentEvidence: FC<IProps> = ({student, subject}) => {
  const { t } = useTranslation()
  
  const {
    data: learningStyle,
  } = useGET_learningStyleQuestionsQuery(student.student_profile?.id, {skip: !student})
    
  const learningCategories = learningStyle?.categories?.map((category) => {
    return {
      name: category.title,
      value: category.percentage,
      fill: category.color_hex_code,
    }
  })

  const deviation = student ? student.baseline_score - 50 : 0

  if(!student) return <></>

  return (
    <>
        <div className="info-row">

                    <div className="info-box">
                        <div className="info-box-title">{t('common.benchmark-what')}</div>
                        <div className="info-box-content">

                            <div className="stats-rows">
                                <div className="stats-row">
                                    <div className="stats-row-label">{t('common.performance')}</div>
                                    <div className="stats-bar">
                                        <div className="stats-bar-fill" style={{ 
                                            width: `${student.baseline_score}%`,
                                            background: '#2136d4ff'
                                    }}></div>
                                        <div className="stats-bar-value">{student.baseline_score}%</div>
                                    </div>
                                </div>
                                <div className="stats-row">
                                    <div className="stats-row-label">{t('common.accuracy-rate')}</div>
                                    <div className="stats-bar">
                                        <div className="stats-bar-fill" style={{ 
                                            width: `${student.accuracy_rate_avg}%`,
                                            background: '#b82aceff'
                                    }}></div>
                                        <div className="stats-bar-value">{student.accuracy_rate_avg}%</div>
                                    </div>
                                </div>
                                <div className="stats-row">
                                    <div className="stats-row-label">{t('common.time-on-task')}</div>
                                    <div className="stats-bar">
                                        <div className="stats-bar-fill" style={{ 
                                            width: `${student.time_on_task_avg}%`,
                                            background: 'orange'
                                    }}></div>
                                        <div className="stats-bar-value">{student.time_on_task_avg}%</div>
                                    </div>
                                </div>
                                <div className="stats-row">
                                    <div className="stats-row-label">{t('common.growth-trend')}</div>
                                    <div className="stats-bar">
                                        <div className="stats-bar-fill" style={{ 
                                            width: `${student.growth_trend_avg > 0 ? student.growth_trend_avg : (-1) * student.growth_trend_avg}%`,
                                            background: student.growth_trend_avg > 0 ? 'rgba(8, 218, 33, 1)' : 'red'
                                    }}></div>
                                        <div className="stats-bar-value">{student.growth_trend_avg}%</div>
                                    </div>
                                </div>
                            </div>
                           
                        </div>
                    </div>

                    {learningCategories?.length > 0 && 
                    <div className="info-box">
                        <div className="info-box-title">{t('common.benchmark-how')}</div>
                        <div className="info-box-content">
                            <div className="stats-rows">
                                {learningCategories.map(c => <div key={c.name} className="stats-row">
                                    <div className="stats-row-label">{c.name}</div>
                                    <div className="stats-bar">
                                        <div className="stats-bar-fill" style={{ 
                                            width: `${c.value}%`,
                                            background: c.fill
                                        }}></div>
                                        <div className="stats-bar-value">{c.value}%</div>
                                    </div>
                                </div>)}
                            </div>
                        </div>
                    </div>}
        
                </div>


               
                <div className="info-row">
                    <div className="info-box">
                        <div className="info-box-title">{t('common.benchmark-why')}</div>
                        <div className="info-box-content">
                            <div className="stats-rows">
                                <div className="stats-row">
                                    <div className="stats-row-label">{t('common.zpd-anchor')}</div>
                                    <div className="stats-bar">
                                        <div className="stats-bar-fill" style={{ 
                                            width: `${student.baseline_score}%`,
                                            background: '#f1b4d3ff'
                                    }}></div>
                                        <div className="stats-bar-label" style={{ textTransform: 'uppercase' }}>{student.zpd_anchor}</div>
                                        <div className="stats-bar-value">{student.baseline_score}%</div>
                                    </div>
                                </div>

                                <div className="stats-row">
                                    <div className="stats-row-label">{t('common.zpd-tag')}</div>
                                    <div className="stats-bar">
                                        <div className="stats-bar-fill" style={{ 
                                            width: `${student.baseline_score}%`,
                                            background: '#a2b1f2ff'
                                    }}></div>
                                        <div className="stats-bar-label" style={{ textTransform: 'uppercase' }}>{student.zpd_tag}</div>
                                        <div className="stats-bar-value">{student.baseline_score}%</div>
                                    </div>
                                </div>

                                <div className="stats-row">
                                    <div className="stats-row-label">{t('common.performance')}</div>
                                    <div className="stats-bar">
                                        <div className="stats-bar-fill" style={{ 
                                            width: `${student.accuracy_rate_avg}%`,
                                            background: '#83e272ff'
                                    }}></div>
                                        <div className="stats-bar-value">{student.accuracy_rate_avg}%</div>
                                    </div>
                                </div>

                                <div className="stats-row">
                                    <div className="stats-row-label">{t('common.bgl-deviation')}</div>
                                    <div className="stats-bar">
                                        <div className="stats-bar-fill" style={{ 
                                            width: `${deviation > 0 ? deviation : -1*deviation }%`,
                                            background: '#65f1c5ff'
                                    }}></div>
                                        <div className="stats-bar-value">{deviation}%</div>
                                    </div>
                                </div>

                                <div className="stats-row">
                                    <div className="stats-row-label">{t('common.risk')}</div>
                                    <div className="stats-bar">
                                        <div className="stats-bar-fill" style={{ 
                                            width: `${student.risk}%`,
                                            background: 'orange'
                                    }}></div>
                                        <div className="stats-bar-value">{student.risk}%</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {student.plop_report && <div className="info-box">
                        <div className="info-box-title">{t('common.present-level-of-performance')}</div>
                        <div className="info-box-content">

                            <div className="stats-rows">

                                <div className="stats-row">
                                    <div className="stats-row-label">{t('common.overall')}</div>
                                    <div className="stats-bar">
                                        <div className="stats-bar-fill" style={{ 
                                                width: `${student.baseline_score}%`,
                                                background: PLOP_COLORS[0]
                                            }}></div>
                                        <div className="stats-bar-value">{student.baseline_score}%</div>
                                    </div>
                                </div>

                                {student.plop_report.category_scores.map((c, idx) => <div key={c.title} className="stats-row">
                                    <div className="stats-row-label">{c.title}</div>
                                        <div className="stats-bar">
                                            <div className="stats-bar-fill" style={{ 
                                                width: `${c.score}`,
                                                background: PLOP_COLORS[idx+1]
                                            }}></div>
                                            <div className="stats-bar-value">{c.score}</div>
                                        </div>
                                </div>)}
                                
                            </div>
                        </div>
                    </div>}        
                </div>
             
  

    </>
  )
}

export default ProgramStudentEvidence